import React from 'react';
import { Route, Switch } from 'react-router';
import Layout from './components/Layout';
import  Home from './components/Home';
import Casinos from './components/Casinos';
import ApuestasDeportivas from './components/ApuestasDeportivas';
import OpinionSite from './components/OpinionSite';
import Bonos from './components/Bonos';
import Comparador from './components/Comparador';
import './custom.css'

const App = () => {
    return (
        <Layout>
            <Switch>
                <Route exact path='/' component={Home} />
                <Route exact path='/apuestasdeportivas' component={ApuestasDeportivas} />
                <Route exact path='/casinos' component={Casinos} />
                {/*<Route exact path='/comparador' component={Comparador} />
                <Route path='/bonos' component={Bonos} />*/}
                <Route path='/:id' component={OpinionSite} />
            </Switch>
       </Layout>
    );
}

export default App;
